import { TextInput as MantineTextInput, TextInputProps } from "@mantine/core"
import { forwardRef } from "react"

import { Label } from "../../../atoms/Label/Label"
import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { Loader } from "../../../molecules/Loader/Loader"

type Props = {
  isLoading?: boolean
  inlineLabel?: boolean
} & TextInputProps

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ isLoading = false, inlineLabel = false, label, value, ...props }, ref) => {
    const input = (
      <MantineTextInput
        ref={ref}
        value={value ?? undefined}
        label={inlineLabel ? undefined : label}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        {...props}
      />
    )

    return inlineLabel ? (
      <EqualWidthGrid>
        <Label label={label} />
        {input}
      </EqualWidthGrid>
    ) : (
      input
    )
  }
)

TextInput.displayName = "TextInput"
